import { MapPinIcon } from "../icons/icons";
import { HorizontalContainer } from "../layout/horizontal-container";
import { VerticalSpacer } from "../layout/vertical-spacer";
import { Text } from "../ui/text";

interface MapPinAndAddressProps {
  address: string;
}

export const MapPinAndAddress = ({ address }: MapPinAndAddressProps) => (
  <div className="map-pin-and-address">
    <HorizontalContainer verticalPlacement="center" noWrap={true}>
      <MapPinIcon />
      <VerticalSpacer size="xx-small" />
      <Text size="small" value={address} weight="bold" />
    </HorizontalContainer>
  </div>
);
